import {ready} from '../main/utils';
import Vue from '../main/vue';
import App from './App.vue';
import router from './routes';
import 'whatwg-fetch';

ready(() => {
  new Vue({
    el: document.querySelector('#rendering-repository-root'),
    comments: true,
    components: {App},
    template: '<App />',
    router
  });
});
